<script setup lang="ts">
import { AuthLoginForm } from '@/modules/auth/components';

useHead({
  title: 'Login',
});

definePageMeta({
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/home',
  },
  layout: 'guest',
});
</script>
<template>
  <v-container class="d-flex align-center hero">
    <AuthLoginForm data-testid="login-form" />
  </v-container>
</template>
<style lang="scss" scoped>
.v-form {
  width: 100%;
  max-width: 500px;
  display: inline-block;
  position: relative;
  margin: auto;
}
</style>
